// store/index.js
import Vue from 'vue';
import Vuex from 'vuex'
import axios from '@/utils/axios'; // 导入封装的 axios 实例

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || null, // 尝试从 localStorage 恢复用户信息
      roleList: [
        {label: '企业用户', value: 1},
        {label: '楼长用户', value: 2},
        {label: '社区用户', value: 3},
        {label: '街道用户', value: 4},
        {label: '普通用户', value: 5},
      ],
      salaryRangeOptions: [
        { label: '1K-5K', value: 1},
        { label: '5K-10K', value: 2},
        { label: '10K-15K', value: 3},
        { label: '15K-20K', value: 4},
        { label: '20K-25K', value: 5},
        { label: '25K-30K', value: 6},
        { label: '30K以上', value: 7}
      ]
    },
    mutations: {
      SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
        localStorage.setItem('userInfo', JSON.stringify(userInfo)); // 将用户信息保存到 localStorage
      },
      CLEAR_USER_INFO(state) {
        state.userInfo = null;
        localStorage.removeItem('userInfo'); // 清除 localStorage 中的用户信息
      },
    },
    actions: {
      async fetchUserInfo({ commit }) {
        try {
          const response = await axios.post('/user/getUserInfo');
          
          if (response.code === 200) {
            commit('SET_USER_INFO', response.data);
          } else {
            console.error('获取用户信息失败:', response.msg);
          }
        } catch (error) {
          console.error('请求用户信息时发生错误:', error);
        }
      },
      logout({ commit }) {
        commit('CLEAR_USER_INFO');
        localStorage.removeItem('token');
      }
    },
    getters: {
      userInfo: state => state.userInfo,
      salaryRangeOptions: state => state.salaryRangeOptions,
      roleList: state => state.roleList
    },
  });
  